import script from "./CreatTestsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatTestsForm.vue?vue&type=script&setup=true&lang=js"

import "./CreatTestsForm.vue?vue&type=style&index=0&id=e466abe0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e466abe0"]])

export default __exports__